export const GET_WORKSHOP_OPENING_HOURS = 'GET_WORKSHOP_OPENING_HOURS';
export const UPDATE_WORKSHOP_OPENING_HOURS = 'UPDATE_WORKSHOP_OPENING_HOURS';
